import React from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import { Container } from '@design-system-etat/dsfr-react';
import { hideAlerte } from '../../store/alertes/alertesReducer';
import styles from './Alertes.module.scss';
import AlerteAutoClosed from './AlerteAutoClosed';

// Fonction pour splitter la description par les sauts de ligne
const renderDescription = (msg) => {
    return <span style={{ whiteSpace: 'pre-line' }}>{msg}</span>;
};

const Alerts = ({ effacerAlerte, alertes }) => {
    return (
        <div className={styles.ContainerAlerts}>
            <div className={styles.ContainerAlerts__Sticky}>
                <Container>
                    {alertes.map((alerte) => {
                        return (
                            <AlerteAutoClosed
                                key={alerte.id}
                                titre={alerte.titre}
                                type={alerte.type}
                                description={renderDescription(alerte.description)}
                                onClose={() => effacerAlerte(alerte.id)}
                            />
                        );
                    })}
                </Container>
            </div>
        </div>
    );
};

Alerts.propTypes = {
    effacerAlerte: PropTypes.func.isRequired,
    alertes: PropTypes.array,
};
export default connect(
    (state) => {
        const { alertes } = state.alertes;

        return { alertes };
    },
    {
        effacerAlerte: hideAlerte,
    },
)(Alerts);
